import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function Counter(props) {
  const {
    countTo,
    isWholeNum = false,
    shouldRoundDown = false,
    suffix = '',
    start = true,
    duration = 1000,
    isSliderActive = false,
    children
  } = props;

  const [count, setCount] = useState(0);
  const [isMounted, setIsMounted] = useState(false);

  const incrementCount = useCallback(() => {
    const interval = 75;
    const steps = duration / interval;
    let incrementBy = countTo / steps;

    if (isMounted) {
      return setCount(countTo);
    }

    if (count + incrementBy > countTo) {
      incrementBy = countTo - count;
      setIsMounted(true);
    }

    if (!isNaN(countTo) && count < countTo && !isSliderActive && start) {
      setTimeout(() => setCount(count + incrementBy), interval);
    }
  }, [count, countTo, duration, isMounted, isSliderActive, start]);

  useEffect(() => {
    incrementCount();
  }, [count, incrementCount]);

  useEffect(
    () => () => {
      setIsMounted(false);
    },
    []
  );

  let value = Math.round(count * 10) / 10;

  if (isWholeNum) {
    value = Math.round(count);
  }

  if (shouldRoundDown) {
    value = Math.floor(count);
  }

  if (suffix) {
    value = value + suffix;
  }

  if (isNaN(countTo)) {
    value = countTo;
  }

  return children({ value });
}

Counter.propTypes = {
  children: PropTypes.func,
  countTo: PropTypes.number.isRequired,
  duration: PropTypes.number,
  isSliderActive: PropTypes.bool,
  isWholeNum: PropTypes.bool,
  shouldRoundDown: PropTypes.bool,
  start: PropTypes.bool,
  suffix: PropTypes.string
};

export default Counter;
